module.exports = __webpack_public_path__ + "static/img/iphone_room1.13d8729.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_room1.png
// module id = trDl
// module chunks = 0